
      import FontBold from './font-bold.vue'
      import type { App, Plugin } from 'vue'

      export const FontBoldPlugin: Plugin = {
        install(app: App) {
          app.component('FontBold', FontBold)
        },
      }
      export { FontBold }
      